<template>
  <BaseModal v-model:is-open="isOpen">
    <template #title>
      <div class="d-flex justify-center align-center title-font">
        <img
          v-if="messageType === '2'"
          src="~/assets/images/icons/ic_warning.png"
          class="mr-3 icons"
        />
        <img
          v-else-if="messageType === '4'"
          src="~/assets/images/icons/ic_check_circle.png"
          class="mr-3 icons"
        />
        <img
          v-else
          src="~/assets/images/icons/ic_information_slab_circle.svg"
          class="mr-3 icons"
        />
        <span v-if="messageType === '4'">完了</span>
        <span v-else>確認</span>
      </div>
    </template>
    <template #contents>
      <span class="body-font">{{ message }}</span>
    </template>
    <template #actionButtons>
      <CustomButton width="100%" @click="close">
        OK
      </CustomButton>
    </template>
  </BaseModal>
</template>

<script setup lang="ts">
import type { MessageType } from '~/types/code/code';
import BaseModal from '../base/BaseModal.vue';
import CustomButton from '~/components/common/parts/CustomButton.vue';

const isOpen = defineModel<boolean>('isOpen');

defineProps<{
  message: string;
  messageType: MessageType;
}>();

const emits = defineEmits(['close']);

const close = () => {
  isOpen.value = false;
  emits('close');
};
</script>

<style lang="scss" scoped>
.title-font {
  font-size: 1.5rem !important;
  font-weight: bold;
}

.body-font {
  font-size: 1.25rem !important;
  font-weight: 300;
}

.icons {
  width: 2rem;
  height: 2rem;
}
</style>
